import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import IndexSectionNavigations13 from "../components/navigations/IndexSectionNavigations13";
import IndexSectionFooters7 from "../components/footers/IndexSectionFooters7";

const meta = {
  title: "プライバシーポリシー | らくらくQRシステム",
  meta: [
    {
      name: "description",
      content:
        "プライバシーポリシー - らくらくQRシステムの個人情報保護に関する方針を掲載しています。",
    },
  ],
};

export default function Privacy() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta} />
      </HelmetProvider>
      <IndexSectionNavigations13 />
      <main>
        {/* ヒーローセクション */}
        <section className="relative pt-24">
          <div className="container px-4 mx-auto">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="font-heading text-5xl xs:text-6xl md:text-5xl font-bold text-gray-900 mb-4">
                プライバシーポリシー
              </h1>
              <p className="mt-4 text-lg text-gray-600">
                お客様の個人情報保護を最優先に考えた当社の方針をここに記載しております。
              </p>
            </div>
          </div>
        </section>

        {/* プライバシーポリシー詳細セクション */}
        <section className="py-16 bg-white">
          <div className="container px-4 mx-auto max-w-4xl">
            <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300 mb-2">
              <h2 className="text-2xl font-bold text-gray-800">
                1. 個人情報の収集
              </h2>
              <p className="text-gray-600 leading-relaxed">
                当社はお問い合わせやサービスのご利用に際し、必要となる個人情報（氏名、メールアドレス、電話番号等）を適法かつ適正な手段により収集いたします。
              </p>
            </div>
            <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300 mb-2">
              <h2 className="text-2xl font-bold text-gray-800">
                2. 個人情報の利用目的
              </h2>
              <p className="text-gray-600 leading-relaxed">
                収集した個人情報は、サービス提供、ユーザーサポート、情報提供、ならびに当社の業務改善やマーケティング活動のために利用されます。
              </p>
            </div>
            <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300 mb-2">
              <h2 className="text-2xl font-bold text-gray-800">
                3. 個人情報の第三者提供
              </h2>
              <p className="text-gray-600 leading-relaxed">
                原則として、本人の同意なく第三者へ個人情報を提供することはありません。ただし、法令に基づく場合や緊急の場合はこの限りではありません。
              </p>
            </div>
            <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300 mb-2">
              <h2 className="text-2xl font-bold text-gray-800">
                4. 個人情報の安全管理
              </h2>
              <p className="text-gray-600 leading-relaxed">
                当社は、個人情報の漏洩・紛失・不正アクセスを防止するために、合理的な安全対策を講じ、厳重に管理いたします。
              </p>
            </div>
            <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300 mb-2">
              <h2 className="text-2xl font-bold text-gray-800">
                5. プライバシーポリシーの変更
              </h2>
              <p className="text-gray-600 leading-relaxed">
                法令の改正やサービス内容の変更に伴い、本プライバシーポリシーを予告なく変更する場合があります。最新の内容は当社のウェブサイトにて随時公開いたします。
              </p>
            </div>
          </div>
        </section>
      </main>
      <IndexSectionFooters7 />
    </React.Fragment>
  );
}
